import '../AllCss/PageSkeleton.css';

export function AppointmentBookingSkeleton() {
  return (
    <div className="page-skeleton page-skeleton--appointment" aria-busy="true" aria-label="Loading appointment">
      <div className="page-skeleton-hero" />
      <div className="page-skeleton-grid">
        <div className="page-skeleton-card page-skeleton-card--wide" />
        <div className="page-skeleton-card" />
        <div className="page-skeleton-card" />
        <div className="page-skeleton-card page-skeleton-card--tall" />
      </div>
    </div>
  );
}

export default AppointmentBookingSkeleton;
